var exports = {
  "K": "RecipientRemoveMessage.module__icon___MWtudk",
};

module.exports = exports;
